import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-881a09c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paramContainer" }
const _hoisted_2 = { class: "parameterName" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Seleccionar periodo para graficar")
const _hoisted_4 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_5 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("24H")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("1S")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("1M")
const _hoisted_9 = {
  key: 0,
  class: "header-tmoa"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Tipología de Matrices Ópticas del Agua (TMOAs) ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Ver más")
const _hoisted_12 = {
  key: 1,
  class: "header-tmoa"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Ver más")
const _hoisted_14 = {
  key: 1,
  style: {"width":"100%","height":"22vh","margin-left":"2px"},
  ref: "parameterChartRef",
  id: "chartParameterData"
}
const _hoisted_15 = { class: "bottom-right" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Media integrada diaria ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Ver más")
const _hoisted_19 = ["id"]
const _hoisted_20 = {
  key: 1,
  class: "no-data-message-img"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-text" }, "No hay datos disponibles en el periodo seleccionado", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  class: "dialog-footer",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Importación de muestras integradas ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cerrar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "detail-point" }, {
      header: _withCtx(() => [
        _createVNode(_component_el_row, {
          class: "card-header",
          type: "flex",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 6,
              class: "parameter-col"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.parameterName), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "date-title" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  class: "block",
                  span: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.startDatePicker,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDatePicker) = $event)),
                        _ctx.resetDateHoursStart
                      ],
                      type: "datetime",
                      format: _ctx.$t('format.dateTime'),
                      "start-placeholder": "Start Date",
                      style: {"margin-right":"5px"},
                      onChange: _ctx.onDateChange,
                      "disabled-date": _ctx.disabledData
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (_ctx.hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "format", "onUpdate:modelValue", "onChange", "disabled-date"]),
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.endDatePicker,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDatePicker) = $event)),
                        _ctx.resetDateHoursEnd
                      ],
                      type: "datetime",
                      format: _ctx.$t('format.dateTime'),
                      "end-placeholder": "End Date",
                      onChange: _ctx.onDateChange,
                      "disabled-date": _ctx.dateFuture
                    }, {
                      default: _withCtx((cell) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["cell", { current: cell.isCurrent }])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ text: true, nodata: _ctx.dateFuture(cell.date) })
                          }, _toDisplayString(cell.text), 3),
                          (_ctx.hasEstimatedData(cell.date))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "format", "onUpdate:modelValue", "onChange", "disabled-date"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: "24 horas",
                          placement: "bottom-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "btn blue",
                              id: "btnDay",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickBtn('btnDay')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: "1 semana",
                          placement: "bottom-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "btn",
                              id: "btnWeek",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickBtn('btnWeek')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: "1 mes",
                          placement: "bottom-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "btn",
                              id: "btnMonth",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickBtn('btnMonth')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (
        _ctx.parameterCode.toLowerCase().trim() == 'tmoa' ||
        _ctx.parameterSubtype.toLowerCase().trim() == 'optical'
      )
          ? (_openBlock(), _createElementBlock("div", {
              style: {"width":"100%","height":"26vh"},
              id: "charttmoa",
              key: _ctx.parameterCode
            }, [
              (_ctx.parameterCode.toLowerCase().trim() == 'tmoa')
                ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_el_link, {
                      class: "btn-see-more",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToReport()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.parameterName) + " ", 1),
                    _createVNode(_component_el_link, {
                      class: "btn-see-more",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToReport()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", null, [
                  _hoisted_16,
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "La gráfica de la media integrada diaria muestra los valores medios diarios de las estimaciones."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "info",
                        size: "small",
                        circle: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_link, {
                  class: "btn-see-more",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToReport()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ], 512))
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      width: "65%",
      "show-close": false,
      title: `Muestras integradas de las estimaciones de ${_ctx.parameterName} del ${_ctx.formatDate(
      _ctx.startDate
    )} al ${_ctx.formatDate(_ctx.endDate)}`,
      onOpened: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createTable()))
    }, {
      default: _withCtx(() => [
        (_ctx.hasDataResult !== null && _ctx.hasDataResult)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _ctx.chartdialog,
              style: {"width":"100%","height":"450px"}
            }, null, 8, _hoisted_19))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22)),
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "medium",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToIntegradas()))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModal())),
            size: "medium",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}